/**
 *
 * @param ms
 * @returns {Promise<unknown>}
 */

export default (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));
